import React, { useEffect, useState } from "react";
import {
  BarChartOutlined,
  BorderlessTableOutlined,
  IdcardOutlined,
  LinkOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  MdOutlineCancel,
  MdOutlineCancelPresentation,
  MdOutlinePayments,
  MdOutlinePointOfSale,
  MdOutlineMoneyOff, MdOutlineTextSnippet,
  MdOutlineRateReview,
} from "react-icons/md";
import { BiMoneyWithdraw, BiTransfer } from "react-icons/bi";
import { GiReceiveMoney } from "react-icons/gi";
import { FiUsers } from "react-icons/fi";
import { VscLiveShare } from "react-icons/vsc";
import { RiOrganizationChart } from "react-icons/ri";
import {
  FaClipboardList,
  FaFileContract,
  FaHandHoldingUsd,
  FaHistory,
  FaRegFilePowerpoint,
} from "react-icons/fa";

import { Item, Link, Logo, Menu, Sider, SubMenu, TecpayLogo } from "../styles";
import { ISideMenuProps } from "../types";
import { RoutesEnum } from "../../../routes/types";
import {
  FaFileCircleCheck,
  FaMobileScreenButton,
  FaMoneyBillTransfer,
  FaRotate,
} from "react-icons/fa6";
import { CiMoneyBill, CiShoppingCart, CiViewTable } from "react-icons/ci";
import { IConfigData } from "../../../store/config/types";
import { isHiddenFeatureDomain } from "../../../config";
import { PortalPermissions, can, canAny } from "../../../config/permissions";
import logo from "../../../assets/tecpay-no-bg.png";
import { LiaFileSignatureSolid } from "react-icons/lia";

const SideMenu: React.FC<ISideMenuProps> = (props: ISideMenuProps) => {
  const { collapsed } = props;
  const [primaryColor, setPrimaryColor] = useState("");
  const [logoUrl, setLogoUrl] = useState("");

  useEffect(() => {
    const domain = window.location.hostname;
    const cachedConfig: IConfigData = JSON.parse(
      localStorage.getItem(`config_${domain}`) as string
    );
    if (cachedConfig) {
      setPrimaryColor(cachedConfig.corPrimaria);
      setLogoUrl(cachedConfig.linkImagem2);
    } else {
      setPrimaryColor("#0e2b27");
    }
  }, []);

  return (
    <Sider
      width={230}
      className="site-layout-background"
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{ backgroundColor: primaryColor }}
    >
      <Logo to={RoutesEnum.Vendas}>
        <TecpayLogo src={logoUrl || logo} />
      </Logo>
      <Menu
        mode="inline"
        theme="dark"
        style={{ backgroundColor: primaryColor }}
      >
        {/* O grupo só aparece se ao menos um item dentro dele aparecer: os itens já
            eram condicionados por can(), mas o SubMenu não — e um grupo vazio no
            menu sugere acesso que a pessoa não tem. */}
        {canAny(
          PortalPermissions.administracao.usuarios.acessar,
          PortalPermissions.administracao.empresas.acessar,
          PortalPermissions.administracao.taxasAntecipacao.acessar,
          PortalPermissions.administracao.pesquisaNps.acessar
        ) && (
        <SubMenu key="admin" title="Administrador" icon={<UserOutlined />}>
          {can(PortalPermissions.administracao.usuarios.acessar) && (
            <Item key="admin-1" icon={<FiUsers />}>
              <Link to="/admin/usuarios">Usuários</Link>
            </Item>
          )}
          {/*<Item key="admin-2" icon={<BsArrowLeftRight />}>
            <Link to="/tecpay/admin/transacoes-nossa-cidade">
              Transações Nossa Cidade
            </Link>
          </Item>
          <SubMenu key="admin-payments" title="Cartão de crédito/débito" icon={<CreditCardOutlined />}>
            <Item key="admin-payments-1">
              <Link to="/tecpay/admin/cancelamentos">
                Cancelamentos
              </Link>
            </Item>
            <Item key="admin-payments-2">
              <Link to="/tecpay/admin/chargebacks">
                Chargebacks
              </Link>
            </Item>
          </SubMenu>
          <Item key="3" icon={<MdAttachMoney />}>
            <Link to="/tecpay/admin/vendas">
              Vendas
            </Link>
          </Item>
          <Item key="4" icon={<GiReceiveMoney />}>
            <Link to="/tecpay/admin/adiantamentos">
              Adiantamentos
            </Link>
          </Item>
          <Item key="5" icon={<GoNote />}>
            <Link to="/tecpay/admin/notaPromissoria">
              Notas Promissorias
            </Link>
          </Item>
          <Item icon={<FileSearchOutlined />} key="credenciais">
            <Link to="/tecpay/admin/credenciais/criar-credencial">
              Credenciais
            </Link>
          </Item> */}
          {can(PortalPermissions.administracao.empresas.acessar) && (
            <Item icon={<IdcardOutlined />} key="business">
              <Link to="/admin/empresas">Empresas</Link>
            </Item>
          )}
          {/* Vincular Empresa saiu do portal (B6): o vínculo usuário↔empresa passou
              a ser administrado no VAULT, junto com perfil e hierarquia. */}
          {can(PortalPermissions.administracao.taxasAntecipacao.acessar) && (
            <Item icon={<FaMoneyBillTransfer />} key="anticipation-fee">
              <Link to="/admin/login-cadastrar-taxas-antecipacao">
                Cadastrar Taxas Antecipação Pontual
              </Link>
            </Item>
          )}
          {can(PortalPermissions.administracao.pesquisaNps.acessar) && (
            <Item icon={<MdOutlineRateReview />} key="nps">
              <Link to="/admin/pesquisa-nps">Pesquisa NPS</Link>
            </Item>
          )}
          {/*<SubMenu key="cadastro-geral" title="Cadastro Geral" icon={<FaBullseye />}>*/}
          {/*</SubMenu>*/}
          {/*<Item icon={<AiFillWallet />} key="wallet">*/}
          {/*  <Link to="/tecpay/admin/carteira-virtual">*/}
          {/*    Carteira Virtual*/}
          {/*  </Link>*/}
          {/*</Item>*/}
          {/*<Item icon={<UserAddOutlined />} key="conta-digital-2-proxy">*/}
          {/*  <Link to="/conta-digital/proxy">*/}
          {/*    Proxy*/}
          {/*  </Link>*/}
          {/*</Item>*/}
        </SubMenu>
        )}
        {/* <SubMenu key="conta-digital" title="Conta Digital" icon={<MdOutlineAccountBalanceWallet />}>
          <Item icon={<FileSearchOutlined />} key="conta-digital-1">
            <Link to="/conta-digital/extrato">
              Extrato
            </Link>
          </Item>
          <Item icon={<FaRegFilePowerpoint />} key="conta-digital-2">
            <Link to="/contas-digitais/politicas-cobrancas">
              Políticas de cobranças
            </Link>
          </Item>
        </SubMenu> */}
        {/*  <SubMenu key="boletos" title="Boleto" icon={<BarcodeOutlined />}>
          <Item key="boletos-1" icon={<MdOutlineRequestPage />}>
            <Link to="/boletos/pagamentos">
              Pagamentos
            </Link>
          </Item>
          <Item key="boletos-2" icon={<AiOutlineProfile />}>
            <Link to="/boletos">
              Boletos
            </Link>
          </Item>
          <Item key="boletos-3" icon={<AiOutlineFilePdf />}>
            <Link to="/boletos/gerar-boleto/cnab">
              Gerar Boleto CNAB
            </Link>
          </Item>
        </SubMenu>
        <SubMenu key="cartao" title="Cartão" icon={<AiFillCreditCard />}>
          <Item icon={<FaRegCreditCard />}>
            <Link to="/conta-digital/carga-cartao">
              Recarregar Cartão
            </Link>
          </Item>
          <Item icon={<FileSearchOutlined />}>
            <Link to="/conta-digital/extrato-cartao">
              Extrato Cartão
            </Link>
          </Item>
        </SubMenu>
        <SubMenu key="pix" title="Pix" icon={<QrcodeOutlined />}>
          <Item key="pix-1" icon={<BiCopy />}>
            <Link to="/pix/copia-e-cola">
              Recebimento
            </Link>
          </Item>
          <Item key="pix-2" icon={<BsBoxArrowUp />}>
            <Link to="/pix/pagamentos">
              Pagamentos
            </Link>
          </Item>
        </SubMenu> */}
        {canAny(
          PortalPermissions.transacoes.vendas.acessar,
          PortalPermissions.transacoes.recebiveis.acessar,
          PortalPermissions.transacoes.depositos.acessar,
          PortalPermissions.transacoes.pagamentos.acessar,
          PortalPermissions.transacoes.reprocessamento.acessar,
          PortalPermissions.cancelamentos.cancelarVenda.acessar,
          PortalPermissions.cancelamentos.historico.acessar,
          PortalPermissions.edi.detalhes.acessar,
          PortalPermissions.edi.gerenciador.acessar
        ) && (
        <SubMenu
          key="repasses"
          title="Transações e Repasses"
          icon={<BiTransfer />}
        >
          {/* <Item icon={<BsCardList />} key="detail">
            <Link to="/tecpay/admin/transacoes-repasse">
              Detalhes
            </Link>
          </Item>
          <Item icon={<VscLiveShare />} key="live">
            <Link to="/tecpay/admin/transacoes-tempo-real">
              Transações em Tempo Real
            </Link>
          </Item>
          <Item icon={<HiOutlineAdjustments />} key="adjustments">
            <Link to="/tecpay/admin/ajustes">
              Ajustes
            </Link>
          </Item>
          <Item icon={<RiFolderTransferLine />} key="repasses">
            <Link to="/tecpay/admin/repasses">
              Repasses
            </Link>
          </Item>
          <Item icon={<BiTransferAlt />} key="transferenciaRepasses">
            <Link to="/tecpay/admin/repasses/transferencias">
              Transferencias de Repasses
            </Link>
          </Item> */}
          {can(PortalPermissions.transacoes.vendas.acessar) && (
            <Item icon={<VscLiveShare />} key="painelVendas">
              <Link to="/admin/painel-de-vendas">Vendas</Link>
            </Item>
          )}
          {can(PortalPermissions.transacoes.recebiveis.acessar) && (
            <Item icon={<VscLiveShare />} key="painelRecebiveis">
              <Link to="/admin/painel-de-recebiveis">Recebíveis</Link>
            </Item>
          )}
          {can(PortalPermissions.transacoes.pagamentos.acessar) && (
            <Item icon={<VscLiveShare />} key="painelDePagamentos">
              <Link to="/admin/painel-de-pagamentos">Pagamentos</Link>
            </Item>
          )}
          {can(PortalPermissions.transacoes.depositos.acessar) && (
            <Item icon={<VscLiveShare />} key="painelDeDepositos">
              <Link to="/admin/painel-de-depositos">Depósitos</Link>
            </Item>
          )}
          {can(PortalPermissions.transacoes.reprocessamento.acessar) && (
            <Item icon={<FaRotate />} key="reprocessamentoTransacoes">
              <Link to="/admin/reprocessamento-transacoes">Reprocessamento de Transações</Link>
            </Item>
          )}
        </SubMenu>
        )}
        {canAny(
          PortalPermissions.cancelamentos.cancelarVenda.acessar,
          PortalPermissions.cancelamentos.historico.acessar
        ) && (
          <SubMenu
            key="cancelamento"
            title="Painel de Cancelamentos"
            icon={<MdOutlineCancelPresentation />}
          >
            {can(PortalPermissions.cancelamentos.cancelarVenda.acessar) && (
              <Item icon={<MdOutlineCancel />} key="painelDeCancelamentos">
                <Link to="/admin/login-cancelamento">Cancelamento de Venda</Link>
              </Item>
            )}
            {can(PortalPermissions.cancelamentos.historico.acessar) && (
              <Item icon={<FaHistory />} key="historicoDeCancelamentos">
                <Link to="/admin/historico-de-cancelamentos">
                  Histórico de Cancelamentos
                </Link>
              </Item>
            )}
          </SubMenu>
        )}
        {canAny(PortalPermissions.edi.detalhes.acessar, PortalPermissions.edi.gerenciador.acessar) && (
          <SubMenu key="adiqEdi" title="EDI Adiq" icon={<CiMoneyBill />}>
            {can(PortalPermissions.edi.detalhes.acessar) && (
              <Item icon={<CiViewTable />} key="detalhesEdi">
                <Link to="/admin/detalhes-edi">Detalhes</Link>
              </Item>
            )}
            {can(PortalPermissions.edi.gerenciador.acessar) && (
              <Item icon={<RiOrganizationChart />} key="gerenciadorEdi">
                <Link to="/admin/gerenciador-edi">Gerenciador de Arquivos</Link>
              </Item>
            )}
          </SubMenu>
        )}

        {canAny(
          PortalPermissions.cobrancas.menu.acessar,
          PortalPermissions.cobrancas.produtosContratados.acessar,
          PortalPermissions.cobrancas.cobrancaPontual.acessar,
          PortalPermissions.cobrancas.antecipacaoPontual.acessar,
          PortalPermissions.cobrancas.historicoAntecipacao.acessar,
          PortalPermissions.cobrancas.chargebacks.acessar
        ) && (
        <SubMenu
          key="gestaoCobranca"
          title="Gestão de Cobranças"
          icon={<CiMoneyBill />}
        >
          {can(PortalPermissions.cobrancas.menu.acessar) && (
            <Item icon={<MdOutlinePointOfSale />} key="menuCobrancas">
              <Link to="/admin/menu-cobrancas">Menu de Cobranças</Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.cobrancaPontual.acessar) && (
            <Item icon={<FaHistory />} key="cobrancaAvulsa">
              <Link to="/admin/login-cobranca-avulsa">Cobrança Pontual</Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.produtosContratados.acessar) && (
            <Item icon={<LiaFileSignatureSolid />} key="assinaturas">
              <Link to="/admin/login-assinaturas">Produtos Contratados</Link>
              <Link to="/admin/login-assinaturas">Assinaturas</Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.antecipacaoPontual.acessar) && (
            <Item icon={<FaHandHoldingUsd />} key="antecipacao">
              <Link to="/admin/login-antecipacao">Antecipação Pontual</Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.historicoAntecipacao.acessar) && (
            <Item icon={<FaHistory />} key="historicoAntecipacao">
              <Link to="/admin/historico-antecipacao">
                Histórico de Antecipações
              </Link>
            </Item>
          )}

          {can(PortalPermissions.cobrancas.chargebacks.acessar) && (
            <Item icon={<FaHandHoldingUsd />} key="chargeback">
              <Link to="/admin/login-chargeback">
                Chargebacks
              </Link>
            </Item>
          )}
        </SubMenu>
        )}

        {canAny(PortalPermissions.liquidacao.vendas.acessar, PortalPermissions.liquidacao.recebiveis.acessar) && (
          <SubMenu
            key="detalheLiquidacao"
            title="Detalhamento Liquidação"
            icon={<BiMoneyWithdraw />}
          >
            {can(PortalPermissions.liquidacao.vendas.acessar) && (
              <Item icon={<GiReceiveMoney />} key="detalheVendas">
                <Link to="/admin/login-vendas">Vendas</Link>
              </Item>
            )}

            {can(PortalPermissions.liquidacao.recebiveis.acessar) && (
              <Item icon={<GiReceiveMoney />} key="detalheLiquidacao">
                <Link to="/admin/login-recebiveis">Recebíveis</Link>
              </Item>
            )}
          </SubMenu>
        )}

        {/* <SubMenu key="veiculos" title="Veículos" icon={<CarOutlined />}>
          <Item key="veiculos-1" icon={<MdOutlineEmojiTransportation />}>
            <Link to="/veiculos">
              Meus Veículos
            </Link>
          </Item>
          <SubMenu key="veiculos-debitos-veiculares" title="Débitos Veiculares" icon={<CarryOutOutlined />}>
            <Item key="veiculos-debitos-veiculares-1">
              <Link to="/debitos-veiculares/pagamentos">
                Meus Pagamentos
              </Link>
            </Item>
            <Item key="veiculos-debitos-veiculares-2">
              <Link to="/debitos-veiculares/debitos">
                Débitos
              </Link>
            </Item>
            <Item key="veiculos-debitos-veiculares-3">
              <Link to="/debitos-veiculares/multas-renainf">
                Multas Renainf
              </Link>
            </Item>
          </SubMenu>
        </SubMenu> */}
        {can(PortalPermissions.financeiro.politicasCobranca.acessar) && (
          <Item icon={<FaRegFilePowerpoint />} key="cadastro-geral-1">
            <Link to="/admin/cadastro-geral/politicas-cobranca">
              Políticas de Cobrança
            </Link>
          </Item>
        )}
        {!isHiddenFeatureDomain()
          && canAny(PortalPermissions.simulador.recebimento.acessar, PortalPermissions.simulador.venda.acessar) && (
          <SubMenu
            key="simulador"
            title="Simulador"
            icon={<BorderlessTableOutlined />}
          >
            {can(PortalPermissions.simulador.recebimento.acessar) && (
              <Item key="simulador-recebimento">
                <Link to="/simulador/recebimento">Quero receber</Link>
              </Item>
            )}
            {can(PortalPermissions.simulador.venda.acessar) && (
              <Item key="simulador-venda">
                <Link to="/simulador/venda">Quero vender por</Link>
              </Item>
            )}
          </SubMenu>
        )}
        {can(PortalPermissions.terminais.phoebus.acessar) && (
          <Item icon={<FaMobileScreenButton />} key="terminaisPhoebus">
            <Link to="/terminaisPhoebus">Terminais</Link>
          </Item>
        )}
        {/*<Item icon={<FaMobileScreenButton />} key="terminais">*/}
        {/*  <Link to="/terminais">*/}
        {/*    Terminais*/}
        {/*  </Link>*/}
        {/*</Item>*/}
        {can(PortalPermissions.comercial.dashboard.acessar) && (
          <Item icon={<BarChartOutlined />} key="dashboard-comercial">
            <Link to="/comercial/dashboard">Dashboard Comercial</Link>
          </Item>
        )}
        {can(PortalPermissions.administracao.cadastroCliente.acessar) && (
          <Item icon={<CiShoppingCart />} key="cadastro">
            <a href="https://form.jotform.com/251784859707070" target="_blank">
              Cadastro de cliente
            </a>
          </Item>
        )}

        {canAny(
          PortalPermissions.contratos.efeitosCumpridos.acessar,
          PortalPermissions.contratos.consultaEfeitos.acessar,
          PortalPermissions.contratos.cadastroCredores.acessar
        ) && (
          <SubMenu
            key="efeitoContrato"
            title="Efeitos de Contrato"
            icon={<FaFileContract />}
          >
            {can(PortalPermissions.contratos.efeitosCumpridos.acessar) && (
              <Item icon={<FaFileCircleCheck />} key="efeitoContrato">
                <Link to="/admin/efeito-contrato">Efeitos Cumpridos</Link>
              </Item>
            )}

            {can(PortalPermissions.contratos.consultaEfeitos.acessar) && (
              <Item icon={<FaClipboardList />} key="consultaEfeito">
                <Link to="/admin/consulta-efeito">Consulta de Efeitos</Link>
              </Item>
            )}

            {can(PortalPermissions.contratos.cadastroCredores.acessar) && (
              <Item icon={<FaClipboardList />} key="cadastroCredor">
                <Link to="/admin/cadastro-credor">Cadastro de Credores</Link>
              </Item>
            )}
          </SubMenu>
        )}

        {canAny(PortalPermissions.slc.pagamentos.acessar, PortalPermissions.slc.liquidacoesFalhas.acessar) && (
          <SubMenu key="slc" title="Detalhes SLC" icon={<MdOutlinePayments />}>
            {can(PortalPermissions.slc.pagamentos.acessar) && (
              <Item key="slc-pagamentos" icon={<MdOutlinePayments />}>
                <Link to="/slc/pagamentos">Pagamentos</Link>
              </Item>
            )}

            {can(PortalPermissions.slc.liquidacoesFalhas.acessar) && (
              <Item key="slc-liquidacoesFalhas" icon={<MdOutlineMoneyOff />}>
                <Link to="/slc/liquidacoes-falhas">Liquidações Falhas</Link>
              </Item>
            )}
          </SubMenu>
        )}

        {can(PortalPermissions.financeiro.extrato.acessar) && (
          <Item icon={<BarChartOutlined />} key="paymentStatement">
            <Link to="/admin/extrato">Extrato</Link>
          </Item>
        )}

        {can(PortalPermissions.contratos.contratosTermos.acessar) && (
          <Item key="contracts" icon={<MdOutlineTextSnippet />}>
            <Link to="/admin/contracts-history">Contratos e termos</Link>
          </Item>
        )}

        {/*<Item key="fees" icon={<MdOutlineMoneyOff/>}>
          <Link to="/admin/fees">Taxas</Link>
        </Item>*/}
      </Menu>
    </Sider>
  );
};
export default SideMenu;
